export const statusTagIntlIds = {
  active: 'statusTagIntlIds.active',
  inactive: 'statusTagIntlIds.inactive',
};
